import type { AppRouter } from '@repo/api/trpc';
import { createTRPCReact } from '@trpc/react-query';

/**
 * 타입이 지정된 tRPC React 훅.
 *
 * AppRouter 는 apps/api 에서 추론된 타입이며 `import type` 이므로 번들에는 포함되지 않는다.
 */
export const trpc = createTRPCReact<AppRouter>();
